import React from 'react'

import CommonImageAnswer, { ImageAnswerProps } from 'themes/common/components/answers/ImageAnswer'

const ImageAnswer = (props: ImageAnswerProps) => {
  return <CommonImageAnswer {...props} intersectionObserverRootSelector=".mobile-question-panel" />
}

export default ImageAnswer
